<template>
    <div class="bg-grey vh-100">

        <!-- HEADER -->
        <div class="header-top bg-white">
            <div class="header-top--inner w-limit d-flex justify-content-between align-items-center">
                <div class="header-top--left" @click="backtodetail" id="backtodetail" v-if="this.dataidpotonganx.islunas===0">
                    <div class="header-item">
                        <img src="../../../assets/icons/back-blue.svg" alt="a">
                    </div>
                </div>
                <div class="header-top--left" @click="backtobayar" v-else>
                    <div class="header-item">
                        <img src="../../../assets/icons/back-blue.svg" alt="a">
                    </div>
                </div>
                <div class="header-top--middle f-cont f-16 f-bold">Riwayat Cicilan Denda</div>
                <div class="header-top--right">
                    <div class="header-item">
                    </div>
                </div>
            </div>
        </div>

        <!-- CONTENT -->
        <div class="content-wrapper main-page">
            <div class="p-x-20 p-y-16 w-limit">
                <div class="f-16 f-c-midgrey f-semi">Total Denda: {{nomial_riwayat | currency}}</div>
                <div class="m-t-16">

                    <div class="cicilan-item-timeline" v-for="riwayatx in riwayat_list" :key="riwayatx.id">
                        <div class="vert-line"></div>
                        <div class="card-item">
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="f-16">{{riwayatx.nominal | currency}}</div>
                                <div class="f-12 f-regular f-c-muted">{{riwayatx.waktu_pembayaran}}</div>
                            </div>
                            <div class="m-t-4 f-12 f-c-midgrey" v-if="riwayatx.saldo>0">Sisa {{riwayatx.saldo | currency}}</div>
                            <div class="m-t-4 f-12 f-c-midgrey cicilan-lunas" v-else>Terbayar lunas</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name:'RiwayatCicilPotongan',
        props:['dataidpotonganx'],
        data(){
            return{
                detailpotonganriwyatx:{},
                namakaryawan_potonganriwyatx:'',
                keterangankaryawan_potonganriwyatx:'',
                saldo_potonganriwyatx:'',
                date_lunas_potonganriwyatx:'',
                waktu_pembayaraan_riwyat:'',

                riwayat_list:[],
                nomial_riwayat:'',
                // namaworkshopx:'',
                // namaoutletx:'',
                // statusoutletx:'',
                // statusworkshopx:'',
                // statuskurirx:'',
                // statusriwayatbayar:0,
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                }
            }
        },
        mounted(){
            this.getriwayat()

			if (this.dataidpotonganx.islunas===0) {
				this.backButtonPressed(this.backtodetail)
			} else {
				this.backButtonPressed(this.backtobayar)
			}
        },
        methods:{
            backtodetail(id){
                this.$emit('backtobayar',{id: this.dataidpotonganx.idpotonganx, islunas: 0})
            },
            backtobayar(id){
                this.$emit('backtodetailcicil',{id: this.dataidpotonganx.idpotonganx, islunas: 0})
            },

            async getriwayat() {
                // this.namaworkshopx = '';
                // this.namaoutletx='';
                // this.statusoutletx='false';
                // this.statusworkshopx='false';
                // this.statuskurirx='false';
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/penggajian/meta/detail_potongan?idpotongan=' + this.dataidpotonganx.idpotonganx,this.requestHeaders);
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            $('#loadingPage').removeClass('overlayLoading');
                            $('#loadingPage').hide()
                            var detailpotonganx = response.data.data.detail.potongan_bayar;
                            var data = response.data.data
                            this.waktu_pembayaraan_riwyat = data.waktu_pembayaran_terakhir
                            this.nomial_riwayat = response.data.data.detail.nominal
                            for (var i = detailpotonganx.length; i > 0; i--) {
                                this.riwayat_list.push({
                                    nama:detailpotonganx[i-1].NamaKaryawan,
                                    id:detailpotonganx[i-1].IdPotongan,
                                    keterangan:detailpotonganx[i-1].Keterangan,
                                    saldo:detailpotonganx[i-1].sisa_saldo,
                                    nominal:detailpotonganx[i-1].nominal,
                                    waktu:detailpotonganx[i-1].WaktuPotongan,
                                    tanggal_lunas:detailpotonganx[i-1].WaktuPembayaranTerakhir,
	                                waktu_pembayaran: detailpotonganx[i-1].waktu_pembayaran.replace("T", " ").replace("+07:00", "")
                                })
                            }
                        }
                    }

                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').removeClass('overlayLoading');
	                $('#loadingPage').hide()
                }
            },
        }
    }
</script>

<style>
.cicilan-item-timeline {
    position: relative;
    display: flex;
}

.cicilan-item-timeline .card-item {
    flex-grow: 1;
    margin-left: 16px;
}

.cicilan-item-timeline:not(:last-child) .card-item {
    margin-bottom: 12px;
}

.cicilan-item-timeline .vert-line {
    width: 2px;
    height: 100%;
    background: #C8D0DD;
    position: absolute;
}

.cicilan-item-timeline .vert-line:before{
    content: '';
    position: absolute;
    left: -6px;
    top: 0;
    width: 14px;
    height: 14px;
    background: #C8D0DD;
    border-radius: 50%;
    border: 4px solid #F2F5F7;
}

.cicilan-item-timeline:first-child .vert-line:before {
    background: #206CFF;
}

.cicilan-item-timeline:last-child .vert-line {
    width: 0px;
}

</style>